import { Component, OnInit, ViewChildren, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adddeduction',
  templateUrl: './adddeduction.component.html',
  styleUrls: ['./adddeduction.component.css']
})
export class AdddeductionComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Deduction";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  deductionColl: any = [];
  deductionBO: any = {};
  deductionid: number = 0

  deductionform = new FormGroup({
    deductionid: new FormControl(0),
    deductionname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.deductionid = params.id
      }
    });

    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.deductionform.reset();
      this.fnInitializeFormGroup();

      if (this.deductionid > 0) {
        this.fngetDeduction();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.deductionid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }

  fnInitializeFormGroup() {
    this.deductionform.setValue({
      deductionid: 0,
      deductionname: '',
      inactive: false
    })
  }

  //Get 
  fngetDeduction() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'deductionid': this.deductionid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getDeduction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.deductionColl = res.json().result;
            var editdata = this.deductionColl[0];
            this.fnEditMode(editdata);
            this.deductionBO=editdata;
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    } 
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.deductionform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'deductionid': this.deductionid,
          'deductionname': this.deductionform.get('deductionname').value,
          'inactive': this.deductionform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckDeduction(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.deductionform.get('deductionid').value > 0) {
                  //Update 
                  this.fnSetDeduction(data);
                }
                else {
                  //Insert 
                  this.fnInsertDeduction(data);
                }
              }
              else {
                if (_checkresult === "name") {this.saveloading = false;

                  this.deductionform.controls['deductionname'].setErrors({ 'notfound': true });
                }
              }
            }
            else {this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertDeduction(data) {

    this.appService.fnInsertDeduction(data).subscribe(
      (res) => {this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new deduction has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.deductionname);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetDeduction(data) {

    this.appService.fnSetDeduction(data).subscribe(
      (res) => {this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The deduction has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.deductionid, data.deductionname);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Deduction']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.deductionform.setValue({
      deductionid: deptBO.deductionid,
      deductionname: deptBO.deductionname,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
